import { createApp } from 'vue'
import QuizComponent from './QuizComponent.vue'
import TestComponent from './TestComponent.vue'
import MemoComponent from './MemoComponent.vue'
import * as quizSets from './data/quiz-questions.json'
import * as testSets from './data/test-questions.json'
import './tailwind.css'
import PuzzleComponent from "@/PuzzleComponent";
import PairingComponent from "@/PairingComponent";
import GroupingComponent from "@/GroupingComponent";
/* eslint-disable no-use-before-define */
import headbreaker from "./vendors/headbreaker";
window.headbreaker = headbreaker

createApp(QuizComponent, {
    questions: quizSets["quiz-miasteczko-drogowe"]
}).mount('#quiz-miasteczko-drogowe')

createApp(QuizComponent, {
    questions: quizSets["quiz-zajecia-w-szkolach-1-4"]
}).mount('#quiz-zajecia-w-szkolach-1-4')

createApp(QuizComponent, {
    questions: quizSets["quiz-zajecia-w-szkolach-5-8"]
}).mount('#quiz-zajecia-w-szkolach-5-8')

createApp(TestComponent, {
    questions: testSets["test-miasteczko-drogowe"]
}).mount('#test-miasteczko-drogowe')

createApp(TestComponent, {
    questions: testSets["test-zajecia-w-szkolach-1-4"]
}).mount('#test-zajecia-w-szkolach-1-4')

createApp(TestComponent, {
    questions: testSets["test-zajecia-w-szkolach-5-8"]
}).mount('#test-zajecia-w-szkolach-5-8')

createApp(MemoComponent).mount('#memo')

createApp(PuzzleComponent, {
    set: 'przedszkola',
}).mount('#puzzle-przedszkola')

createApp(PuzzleComponent, {
    set: '1-4',
}).mount('#puzzle-1-4')

createApp(PuzzleComponent, {
    set: '5-8',
}).mount('#puzzle-5-8')

createApp(PairingComponent).mount('#pairing')

createApp(GroupingComponent, {difficult: 'przedszkola'}).mount('#grouping-przedszkola')
createApp(GroupingComponent, {difficult: '1-4'}).mount('#grouping-1-4')
createApp(GroupingComponent, {difficult: '5-8'}).mount('#grouping-5-8')


